// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-title {\n  background-color: #ffe1ce;\n  font-size: 28pt;\n  line-height: 28pt;\n  font-weight: 550;\n  color: #ff6600;\n}\n.main-description p {\n  margin-bottom: 0px;\n  font-weight: bold;\n  color: #4a030d;\n}\n.v-btn__content {\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
